import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/fund/recharge-icon.png'


const _withScopeId = n => (_pushScopeId("data-v-0b02d058"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  referrerPolicy: "no-referrer",
  src: _imports_0,
  alt: "",
  style: {"display":"inline-block"}
}, null, -1))
const _hoisted_2 = { class: "dialog-header" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "tip" }
const _hoisted_5 = { class: "dialog-body flex-ter" }
const _hoisted_6 = { class: "dialog-footer" }

import { exportShelvedRecordApi } from '@/apis/fund'
import { t } from '@/plugins/i18n'
import { ref } from 'vue'
import { useStore } from 'vuex'
import { ElMessage } from 'element-plus'
import dayjs from 'dayjs'
import axios from 'axios'
import { isChoiceShop } from '@/store'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const dialogVisible = ref(false)
const date = ref([])
const upload = () => {
  if (date.value.length === 0) {
    ElMessage.warning(t('请选择商品上架时间'))
    return
  }
  axios({
    method: 'POST',
    url: process.env.VUE_APP_URL + '/order/customer/platformOrder/exportShelvedRecord',
    responseType: 'blob',
    headers: {
      'X-AuthToken': store.getters.token,
      'X-GRAY-TAG': process.env.VUE_APP_X_GRAY_TAG || '',
      'X-AuthShopId': store.getters.curShop,
      'X-Platform': 'PC',
      'X-Appname': 'ckb-client-pc'
    },
    data: {
      customerShopId: store.getters.curShop,
      shelvedTimeStart: dayjs(date.value[0]).format('YYYY-MM-DD'),
      shelvedTimeEnd: dayjs(date.value[1]).format('YYYY-MM-DD')
    }
  }).then((res: any) => {
    const blob = new Blob([res.data], { type: 'application/vnd.ms-excel' })
    const fileName = t('一口价商品账单')
    const objectUrl = URL.createObjectURL(blob)
    const a = document.createElement('a')
    document.body.appendChild(a)
    a.setAttribute('style', 'display:none')
    a.setAttribute('href', objectUrl)
    a.setAttribute('download', fileName)
    a.click()
    URL.revokeObjectURL(objectUrl)
    ElMessage.success(t('导出成功'))
    dialogVisible.value = false
  })
}
const open = () => {
  date.value = []
  dialogVisible.value = true
}

return (_ctx: any,_cache: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(isChoiceShop)())
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "upload-btn-item",
          onClick: open
        }, [
          _hoisted_1,
          _createElementVNode("span", null, _toDisplayString(_unref(t)('账单导出')), 1)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_el_dialog, {
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((dialogVisible).value = $event)),
      "custom-class": "upload-bill-excel-dialog"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_el_button, {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (dialogVisible.value = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('取消')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: upload
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('确定')), 1)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('导出账单')), 1),
          _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)('当前支持导出一口价商品的账单')), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", null, _toDisplayString(_unref(t)('商品上架时间')), 1),
          _createVNode(_component_el_date_picker, {
            modelValue: date.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((date).value = $event)),
            type: "daterange",
            "start-placeholder": _unref(t)('开始时间'),
            "end-placeholder": _unref(t)('结束时间')
          }, null, 8, ["modelValue", "start-placeholder", "end-placeholder"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})